import React, { useId } from 'react';
import DotWavesS from './DotWavesS';

/**
 * Sistema de fondo (Capas 01–05) + contenedor de contenido (z-10+).
 * Capa 06 (panel elevado) se aplica con clase .sim-main-elevated donde corresponda.
 */
function BackgroundStack({ className = '', children, sidebarExpanded = false, scrollable = false }) {
    const uid = useId();
    const noiseId = `simNoise${uid.replace(/:/g, '')}`;

    return (
        <div
            className={['relative min-h-0 min-w-0', scrollable ? 'overflow-y-auto' : 'overflow-hidden', className].filter(Boolean).join(' ')}
            style={{ backgroundColor: '#e8ecf0' }}
        >
            {/* Capa 01 — Lienzo + grano fractal 5% */}
            <svg
                className="pointer-events-none absolute inset-0 z-0 h-full w-full"
                style={{ opacity: 0.05 }}
                aria-hidden
            >
                <defs>
                    <filter id={noiseId} x="0" y="0" width="100%" height="100%" filterUnits="objectBoundingBox">
                        <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="4" seed="2" result="n" />
                        <feColorMatrix in="n" type="saturate" values="0" result="g" />
                    </filter>
                </defs>
                <rect width="100%" height="100%" filter={`url(#${noiseId})`} fill="#1a1a1a" />
            </svg>

            {/* Capas 02, 04, 05 — Gradiente diagonal frío→neutro→cálido */}
            <div
                className="pointer-events-none absolute inset-0 z-0"
                style={{
                    opacity: 0.55,
                    backgroundImage: `
            radial-gradient(ellipse 100% 85% at 0% 0%, rgba(246, 249, 252, 0.92) 0%, transparent 55%),
            radial-gradient(ellipse 95% 90% at 100% 100%, rgba(249, 244, 238, 0.9) 0%, transparent 50%),
            linear-gradient(165deg, #f6f9fc 0%, #fbfaf6 48%, #f9f4ee 100%)
          `,
                }}
            />

            {/* Capa 03 — Ondas de puntos concéntricas */}
            <DotWavesS sidebarExpanded={sidebarExpanded} />

            <div className="relative z-10 box-border flex h-full min-h-0 w-full min-w-0 flex-1 flex-col">
                {children}
            </div>
        </div>
    );
}

export default BackgroundStack;
